import { CountryConfig } from './types'

export const countryConfigs: Record<string, CountryConfig> = {
  US: {
    label: 'United States',
    postalCodeLabel: 'Zip Code',
    postalCodePattern: /^\d{5}$/,
    postalCodePlaceholder: 'Enter your zip code',
    currencySymbol: '$',
    priceMultiplier: 1.0
  },
  CA: {
    label: 'Canada',
    postalCodeLabel: 'Postal Code',
    postalCodePattern: /^[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/,
    postalCodePlaceholder: 'e.g., K1A 0B1',
    currencySymbol: 'CA$',
    priceMultiplier: 1.35
  },
  UK: {
    label: 'United Kingdom',
    postalCodeLabel: 'Postcode',
    postalCodePattern: /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i,
    postalCodePlaceholder: 'e.g., SW1A 1AA',
    currencySymbol: '£',
    priceMultiplier: 0.79
  },
  AU: {
    label: 'Australia',
    postalCodeLabel: 'Postcode',
    postalCodePattern: /^\d{4}$/,
    postalCodePlaceholder: 'e.g., 2000',
    currencySymbol: 'AU$',
    priceMultiplier: 1.52
  },
  NZ: {
    label: 'New Zealand',
    postalCodeLabel: 'Postcode',
    postalCodePattern: /^\d{4}$/,
    postalCodePlaceholder: 'e.g., 1010',
    currencySymbol: 'NZ$',
    priceMultiplier: 1.63
  },
  DE: {
    label: 'Germany',
    postalCodeLabel: 'Postleitzahl',
    postalCodePattern: /^\d{5}$/,
    postalCodePlaceholder: 'e.g., 10115',
    currencySymbol: '€',
    priceMultiplier: 0.93
  },
  FR: {
    label: 'France',
    postalCodeLabel: 'Code Postal',
    postalCodePattern: /^\d{5}$/,
    postalCodePlaceholder: 'e.g., 75001',
    currencySymbol: '€',
    priceMultiplier: 0.93
  },
  ES: {
    label: 'Spain',
    postalCodeLabel: 'Código Postal',
    postalCodePattern: /^\d{5}$/,
    postalCodePlaceholder: 'e.g., 28001',
    currencySymbol: '€',
    priceMultiplier: 0.93
  },
  IT: {
    label: 'Italy',
    postalCodeLabel: 'CAP',
    postalCodePattern: /^\d{5}$/,
    postalCodePlaceholder: 'e.g., 00100',
    currencySymbol: '€',
    priceMultiplier: 0.93
  },
  MX: {
    label: 'Mexico',
    postalCodeLabel: 'Código Postal',
    postalCodePattern: /^\d{5}$/,
    postalCodePlaceholder: 'e.g., 01000',
    currencySymbol: 'MX$',
    priceMultiplier: 17.2
  }
}

// Maintenance costs over 30 years (per 100 sq ft)
export const maintenanceCosts30Years: Record<string, { inspections: number, repairs: number, cleaning: number, total: number, frequency: string }> = {
  asphalt: { inspections: 900, repairs: 3500, cleaning: 600, total: 5000, frequency: 'Inspections every 2 years, repairs every 10-15 years' },
  metal: { inspections: 900, repairs: 1500, cleaning: 900, total: 3300, frequency: 'Inspections every 3 years, minimal repairs' },
  tile: { inspections: 900, repairs: 2000, cleaning: 1200, total: 4100, frequency: 'Inspections every 3 years, occasional tile replacement' },
  slate: { inspections: 900, repairs: 1000, cleaning: 600, total: 2500, frequency: 'Inspections every 5 years, very rare repairs' },
  standing_seam: { inspections: 900, repairs: 1200, cleaning: 900, total: 3000, frequency: 'Inspections every 3 years, minimal maintenance' },
  copper: { inspections: 900, repairs: 500, cleaning: 1200, total: 2600, frequency: 'Inspections every 5 years, virtually maintenance-free' },
  flat: { inspections: 900, repairs: 4500, cleaning: 1500, total: 6900, frequency: 'Inspections every year, recoating every 10 years' },
  tpo: { inspections: 900, repairs: 3000, cleaning: 1200, total: 5100, frequency: 'Inspections every 2 years, seam repairs' },
  rubber: { inspections: 900, repairs: 3500, cleaning: 1200, total: 5600, frequency: 'Inspections every 2 years, patch repairs' },
  recycled_shingles: { inspections: 900, repairs: 3200, cleaning: 600, total: 4700, frequency: 'Inspections every 2 years, similar to asphalt' },
  solar_tiles: { inspections: 1200, repairs: 2500, cleaning: 2100, total: 5800, frequency: 'Inspections every 2 years, panel cleaning annually' },
  green_roof: { inspections: 1500, repairs: 4000, cleaning: 3500, total: 9000, frequency: 'Inspections every year, plant maintenance seasonally' },
  recycled_metal: { inspections: 900, repairs: 1500, cleaning: 900, total: 3300, frequency: 'Inspections every 3 years, minimal repairs' },
  composite_slate: { inspections: 900, repairs: 1800, cleaning: 600, total: 3300, frequency: 'Inspections every 3 years, occasional repairs' },
}

export const fallbackMaterialRates: Record<string, { low: number; high: number }> = {
  asphalt: { low: 3.5, high: 5.5 },
  metal: { low: 7, high: 12 },
  tile: { low: 10, high: 18 },
  slate: { low: 15, high: 30 },
  flat: { low: 4, high: 8 },
  tpo: { low: 5, high: 9 },
  rubber: { low: 4.5, high: 8 },
  copper: { low: 25, high: 40 },
  standing_seam: { low: 10, high: 16 },
  recycled_shingles: { low: 4, high: 6.5 },
  solar_tiles: { low: 21, high: 35 },
  green_roof: { low: 15, high: 25 },
  recycled_metal: { low: 8, high: 14 },
  composite_slate: { low: 9, high: 15 },
}
